<template lang="pug">
  #companion-landscape-card
    RouterLink(:to="redirectTo")
      .flex-container
        .cover-art-container
            img.is-square(:src="previewImage" :alt="'Not available'")
        .custom-content-box
            .flex-item.category-info-container
                span.category-info(v-if="category") {{ category }}
                //- WtSvgIcon(icon="companion/checkmark_icon" width="18px" height="18px")
            .flex-item.title-container(style="gap:2px;")
              p.title {{ title }}
              p.custom-subtitle(:style="{ '-webkit-line-clamp': subtitleLines }") {{ subTitle }}
            .flex-item.action-timer-container
                WtButton.action-button(:click="redirectToPage") {{ actionType }}
                .timer-container
                    WtSvgIcon(icon="icon_time" width="20px" height="20px" style="padding-top: 4px;")
                    span {{ duration }}
</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "TaskCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    redirectTo: { type: [Object, String], required: true },
    id: { type: String, required: true },
    previewImage: { type: String, default: "" },
    category: { type: String, required: true },
    title: { type: String, default: "" },
    subTitle: {
      type: String,
      default: ""
    },
    duration: { type: String, default: "" },
    actionType: { type: String, default: "" }
  },
  data() {
    return {
      maxLines: 4
    };
  },
  computed: {
    titleLines() {
      return this.calculateTitleLines();
    },
    subtitleLines() {
      return this.maxLines - this.titleLines;
    }
  },
  methods: {
    redirectToPage() {
      switch (this.category) {
        case "guide":
          console.log({
            name: "CompanionGuideDetail",
            params: { guideId: this.id }
          });
          this.$router.push({
            name: "CompanionGuideDetail",
            params: { guideId: this.id }
          });
          break;
        case "strategy":
          this.$router.push({
            name: "CompanionStrategy",
            params: { strategyId: this.id }
          });
          break;
      }
    },
    truncateSummary(paragraph) {
      const num = 105;
      let maxParaGraphLength = num - this.title.length;
      let truncatedParagraph =
        paragraph.length > maxParaGraphLength
          ? paragraph.slice(0, maxParaGraphLength) + "..."
          : paragraph;
      return truncatedParagraph;
    },

    calculateTitleLines() {
      const titleElement = this.createMeasurementElement(this.title);
      const titleHeight = this.getElementHeight(titleElement);
      document.body.removeChild(titleElement);

      const lines = Math.ceil(titleHeight / 20); // Assuming line-height is 20px
      return Math.min(lines, this.maxLines);
    },
    createMeasurementElement(text) {
      const element = document.createElement("p");
      element.style.fontFamily = "Manrope";
      element.style.fontSize = "16px";
      element.style.lineHeight = "20px";
      element.style.width = "210px";
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      element.style.whiteSpace = "pre-wrap";
      element.innerText = text;
      document.body.appendChild(element);
      return element;
    },
    getElementHeight(element) {
      return element.offsetHeight;
    }
  }
};
</script>
<style scoped>
#companion-landscape-card {
  width: 395px;
  padding: 0px;
  border-radius: 8px;
  background: #fff;
}

.flex-container {
  display: flex;
  width: 395px;
  height: 194px;
  padding: 16px;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  flex-shrink: 0;
  min-height: 100%;
  border-radius: 8px;
  background: #fff;
  font-family: Manrope;
  font-style: normal;
  border: 1px solid #d9dbe0;
}
.cover-art-container {
  width: 120px !important;
  min-height: 100%;
  display: flex;
  align-items: center !important;
}

.cover-art-container img {
  border-radius: 8px !important;
  min-width: 120px !important;
  height: 100% !important;
}
.custom-content-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
  min-height: 100%;
  gap: 16px !important;
}

.category-info-container {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.category-info {
  color: #5a5c60 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  font-style: normal !important;
}

.title-container {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.title {
  color: #1b1d20;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
  margin: 0px;
  padding: 0px;
}

.custom-subtitle {
  color: #5a5c60;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-wrap: break-word;
}

.action-timer-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid #2972f0;
  background: #2972f0;
  color: #fff;
  text-align: center;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.timer-container {
  display: flex;
  align-items: center;
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #5a5c60;
}

@media screen and (max-width: 768px) {
  #companion-landscape-card {
    min-width: 49% !important;
    height: max-content !important;
  }
  #companion-landscape-card {
    width: 100%;
  }
  .flex-container {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  #companion-landscape-card {
    min-width: 100% !important;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    height: min-content;
  }
  .cover-art-container {
    display: flex;
    align-items: center !important;
    width: 38% !important;
    gap: 8px;
  }
  .cover-art-container img {
    border-radius: 0.5rem !important;
    min-width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }
  .custom-content-box {
    display: flex;
    width: 58% !important;
    gap: 16px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start !important;
  }
}
</style>
